import api, { setAuthToken, removeAuthToken } from './api';

export const authService = {
    /**
     * Register new member
     */
    register: async (name, email, phone) => {
        const response = await api.post('/auth/register', { name, email, phone });
        if (response.data.token) {
            setAuthToken(response.data.token);
        }
        return response;
    },

    /**
     * Login member (passwordless - email + phone)
     */
    login: async (email, phone) => {
        const response = await api.post('/auth/login', { email, phone });
        if (response.data.token) {
            setAuthToken(response.data.token);
        }
        return response;
    },

    /**
     * Logout current user
     */
    logout: async () => {
        try {
            await api.post('/auth/logout');
        } finally {
            removeAuthToken();
        }
    },

    /**
     * Get current authenticated user
     */
    me: async () => {
        return api.get('/auth/me');
    },

    /**
     * Check if user is authenticated
     */
    isAuthenticated: () => {
        return !!localStorage.getItem('auth_token');
    },
};

export default authService;
